/*eslint-env node*/

"use strict";
var _ = require("underscore");
var css = require("../../includes/css-block/css-block.js").load();

var loadDynamicCss = function(callback) {
    var cssStyles = css.render(css.htmlTemplate, window.JSContext),
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');

    style.type = 'text/css';
    if (style.styleSheet) {
        style.styleSheet.cssText = cssStyles;
    } else {
        style.appendChild(document.createTextNode(cssStyles));
    }
    head.appendChild(style);
    if(_.isFunction(callback)) {
        callback();
    }
};

module.exports.loadDynamicCss = loadDynamicCss;



// WEBPACK FOOTER //
// ./common/dynamic-css-loader.js